module.exports = __webpack_public_path__ + "static/media/PCA_black.55950765.svg";